module.exports = __webpack_public_path__ + "static/media/Grupo 351@2x.f332ea15.png";